<template>
	<span>
		<table v-if="apps_status.length">
			<tr
				v-for="statusMessage in apps_status"
				:key="statusMessage.project"
				:class="statusMessage.color">
				<td>
					<v-chip label small color="#00000022" class="black--text">
						{{ statusMessage.project }}
					</v-chip>
				</td>
				<td class="black--text">
					{{ statusMessage.message }}
				</td>
			</tr>
		</table>
	</span>
</template>

<script>
export default {
	computed: {
		apps_status () {
			let apps_status = this.$store.getters.apps_status
			let statusMessages = []
			for (const key in apps_status) {
				if (apps_status[key].status) {
					let color = 'background'
					if (apps_status[key].status === 1) {
						color = 'green'
					} else if (apps_status[key].status === 2) {
						color = 'orange accent-3'
					} else if (apps_status[key].status === 3) {
						color = 'error'
					}
					statusMessages.push({
						project: key,
						color: color,
						message: apps_status[key].message
					})
				}
			}
			return statusMessages
		}
	}
}
</script>

<style lang="stylus" scoped>
table
	td
		border-bottom: 1px solid black
</style>



// WEBPACK FOOTER //
// src/App_status_message.vue